import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { ComponentWillMountSymbol } from 'feature-components'
import {
	ExternalComponentLoaderSymbol,
	ExternalComponentUiLibProvidersSymbol,
	ExternalComponentWixCodeUrlGeneratorSymbol,
	ExternalComponentCssManagerSymbol,
	ExternalComponentCssApplierSymbol,
	ExternalComponentFetchSymbol,
} from './symbols'
import { ExternalComponentLoader } from './common/externalComponentLoader'
import { ExternalComponentPageDidMount } from './externalComponentPageDidMount'
import { ExternalComponentWillMount } from './externalComponentWillMount'
import ExternalComponentAppWillMount from './externalComponentAppWillMount'
import { ExternalComponentUiLibProviders } from './uiLibProviders'
import { ExternalComponentWixCodeUrlGenerator } from './common/externalComponentWixCodeUrlGenerator'
import { ExternalComponentCssManager } from './common/externalComponentCssManager'
import { ExternalComponentPageDidUnmount } from './externalComponentPageDidUnmount'
import { ExternalComponentCssApplier } from './common/externalComponentCssApplier'
import { ClientFetchFactory } from './common/clientFetchFactory'
import { FETCH_TIMEOUT, FETCH_RETRIES } from './utils/consts'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(ExternalComponentWillMount)
	bind(LifeCycle.PageDidMountHandler).to(ExternalComponentPageDidMount)
	bind(LifeCycle.PageDidUnmountHandler).to(ExternalComponentPageDidUnmount)
}

export const site: ContainerModuleLoader = (bind) => {
	bind(ExternalComponentFetchSymbol).to(
		ClientFetchFactory({ timeout: FETCH_TIMEOUT.CLIENT, maxRetries: FETCH_RETRIES.CLIENT })
	)
	bind(ExternalComponentLoaderSymbol).to(ExternalComponentLoader)
	bind(ExternalComponentUiLibProvidersSymbol).to(ExternalComponentUiLibProviders)
	bind(LifeCycle.AppWillMountHandler).to(ExternalComponentAppWillMount)
	bind(ExternalComponentWixCodeUrlGeneratorSymbol).to(ExternalComponentWixCodeUrlGenerator)
	bind(ExternalComponentCssManagerSymbol).to(ExternalComponentCssManager)
	bind(ExternalComponentCssApplierSymbol).to(ExternalComponentCssApplier)
}

export { getExternalComponentRendererUrl } from './utils/getExternalComponentRendererUrl'
export {
	ExternalComponentDsPublicApiSymbol,
	ExternalComponentAPISymbol,
	ExternalComponentConsentManagerSymbol,
	ExternalComponentUiLibProvidersSymbol,
} from './symbols'
export type { IExternalComponentDsPublicApi, IExternalComponentConsentManager, IExternalComponentSite } from './types'
export type { UiLibProviders } from './uiLibProviders'
